const allowedCountries = [
    "EG", // Egypt
    "US", // USA
    "DZ", // Algeria
    "AU", // Australia
    "BH", // Bahrain
    "CA", // Canada
    "DK", // Denmark
    "EE", // Estonia
    "LB", // Lebanon
    "LY", // Libya
    "MA", // Morocco
    "NL", // Netherlands
    "OM", // Oman
    "PS", // Palestine
    "PT", // Portugal
    "QA", // Qatar
    "FI", // Finland
    "FR", // France
    "DE", // Germany
    "IQ", // Iraq
    "IE", // Ireland
    "IT", // Italy
    "JO", // Jordan
    "KW", // Kuwait
    "SA", // Saudi Arabia
    "SS", // South Sudan
    "ES", // Spain
    "SD", // Sudan
    "SE", // Sweden
    "CH", // Switzerland
    "SY", // Syrian Arab Republic
    "TN", // Tunisia
    "GB", // United Kingdom (UK)
    "AE", // United Arab Emirates (UAE)
    "YE", // Yemen
  ];
  export default allowedCountries;